export default __webpack_public_path__ + "static/media/armin_s.b483bd50.jpg";